var MDB = window.MDB || {};;
MDB.MyAvg = MDB.MyAvg || {};

(function() {

    var _config;

    $.extend(MDB.MyAvg,
        {
        	boot: function(config){
        		_config = config;
        	},
            deleteProject: function(btn, id) {

            	MDB.promptHtml(
	                MDB.loadResourceString('Dpo_MyAvg_Project_Delete_Prompt_Title'), 
	                '<h4><i class="fa fa-trash text-danger"></i> <small>' + MDB.loadResourceString('Dpo_MyAvg_Project_Delete_Prompt_Body') + '</small></h4>', 
	                function(ok){
	                    if (ok) {
			            	MDB.sendAjaxRequest(_config.deleteProjectUrl, {id: id}).done(function(response){
			            		if(response != null && response.errors == 0) {
			            			$(btn).first().parents().closest('.dpo-card').remove()
			            		}
			            	});
	                    }
	                });
            }
        });
})();